// Enum for Awards Name

export enum AwardsName {
    IndividualAwards = 'ACE Individual Award',
    TeamAwards = 'ACE Team Award',
}